import classNames from 'classnames';
import type { StaticImageData } from 'next/image';
import Image from 'next/image';
import type { FC, PropsWithChildren } from 'react';

import { BulletPointsCategory } from '@/services/bullet-points';

type Props = {
  staticImage?: StaticImageData;
  absoluteImageClassName?: string;
  bulletPointsCategory?: BulletPointsCategory;
};

export const getBulletPointCategoryColor = (
  category?: BulletPointsCategory
) => {
  return classNames({
    'bg-jb-alert-300': category === BulletPointsCategory.ACTION_VERB,
    'bg-jb-secondary-300': category === BulletPointsCategory.METRIC,
    'bg-jb-primary-200': category === BulletPointsCategory.STRATEGY,
    'bg-jb-success-200': category === BulletPointsCategory.OUTCOME,
    'bg-transparent': !category,
  });
};

const BulletPointHighlightSpan: FC<PropsWithChildren<Props>> = ({
  absoluteImageClassName,
  bulletPointsCategory,
  staticImage,
  children,
}) => {
  return (
    <span
      className={classNames(
        'relative overflow-visible rounded-full p-1',
        getBulletPointCategoryColor(bulletPointsCategory)
      )}
    >
      {children}
      {staticImage && (
        <Image
          src={staticImage}
          alt=""
          className={classNames(
            absoluteImageClassName,
            'absolute max-w-none hidden lg:flex'
          )}
        />
      )}
    </span>
  );
};

export default BulletPointHighlightSpan;
